import React, { useState } from "react";
import "./signup.css";
import logo from "../../Media/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import db, { auth } from "../../Firebase/config";
import { doc, setDoc } from "firebase/firestore";

const SignUp = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    ghanaCard: "",
    error: null,
    loading: false,
  });
  const navigate = useNavigate();

  const { name, email, password, ghanaCard, error, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!name || !email || !password || !ghanaCard) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      await setDoc(doc(db, "users", result.user.uid), {
        uid: result.user.uid,
        name,
        email,
        ghanaCard,
      });
      setData({
        name: "",
        email: "",
        password: "",
        ghanaCard: "",
        error: null,
        loading: false,
      });
      navigate("/");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };

  return (
    <div className="signup">
      <img src={logo} alt="logo-img" />
      <h2>Create Your Account</h2>
      <div className="signup-form">
        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <br />
          <input
            name="name"
            type="text"
            value={name}
            placeholder="Enter Name"
            onChange={handleChange}
          />
          <br />
          <label>Email</label>
          <br />
          <input
            name="email"
            type="email"
            value={email}
            placeholder="Example@email.com"
            onChange={handleChange}
          />
          <br />
          <label>Ghana Card ID</label>
          <br />
          <input
            name="ghanaCard"
            type="text"
            value={ghanaCard}
            placeholder="Enter Gh card id"
            onChange={handleChange}
          />
          <br />
          <label>Password</label>
          <br />
          <input
            name="password"
            type="password"
            value={password}
            placeholder="Enter Password"
            onChange={handleChange}
          />
          <br />
          {error ? <p className="error">{error}</p> : null}
          <button className="submit-btn" disabled={loading} type="Submit">
            {loading ? "Creating ..." : "Sign Up"}
          </button>
          <p>
            Already have an account? <Link to="/logIn">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
